<prism-ui-page-content
  key-id="page-content"
  >
  
  @if (isAutoSubmitting) {
    <!-- Loading state during auto-submit in continue workflow -->
    <div class="page-loader">
      <prism-ui-loader
        has-logo="false"
        is-reverse="false"
        key-id="auto-submit-loader"
        size="md"
      >
      </prism-ui-loader>
      <prism-ui-copy
        font-size="md"
        font-style="normal"
        font-weight="regular"
        key-id="auto-submit-loading-text"
        line-height="medium"
        text-decoration="none"
        variant="default"
      >
        <span>Please wait while we process your request</span>
      </prism-ui-copy>
    </div>
  } @else {
  
  <prism-ui-heading
    font-size="lg"
    font-weight="regular"
    key-id="employee-info-title"
    is-uppercase="false"
    variant="default"
    >{{pageTitle}}
  </prism-ui-heading>

  <!-- Hide the horizontal rule when reviewing/editing from review so
       the page reads as a single-section view, not a wizard step. -->
  @if (!isEditFromReview) {
    <hr class="horizontalLine">
  }

  <!-- Slightly larger instruction copy in edit/review mode for readability. -->
  @if (isEditFromReview) {
    <prism-ui-copy
      font-size="md"
      font-style="normal"
      font-weight="regular"
      key-id="pageInstruction"
      line-height="medium"
      text-decoration="none"
      variant="default"
      >
      <p>{{pageInstructions[0]}}.</p>
      <p>{{pageInstructions[1]}}.</p>

    </prism-ui-copy>
  } @else {
    <prism-ui-copy
      font-size="sm"
      font-style="normal"
      font-weight="regular"
      key-id="pageInstruction"
      line-height="medium"
      text-decoration="none"
      variant="default"
      >
      <p>{{pageInstructions[0]}}.</p>
      <p>{{pageInstructions[1]}}.</p>

    </prism-ui-copy>
  }

  <form [formGroup]="employeeInfoForm" #formDirective="ngForm" (ngSubmit)="onSubmit()">
    <prism-ui-container
      is-compact="false"
      key-id="employee-info-container"
      has-shadow="false"
      variant="default"
      has-no-border-radius="false"
      >
      <div class="form-group">
        <div class="containerOne">
          <div class="alignItems">
            <div class="item firstName">
              @if (isEmployeeViewMode) {
                <div class="employeeViewMode">
                  <prism-ui-data-display
                    key-id="employeeFirstName-display"
                    [label]="firstNameElement?.label"
                    [value]="employeeInfoForm.get('employeeFirstName')?.value"
                  ></prism-ui-data-display>
                </div>
              } @else {
                <prism-ui-form-field key-id="employeeFirstName" [isValid]="formControlUtilitiesService.isControlValid(employeeInfoForm,'employeeFirstName')">

                  <span slot="label">{{firstNameElement?.label}}</span>
                  <span slot="helper-text">{{ firstNameElement?.hint }}</span>
                  <span slot="error">
                    @if (employeeFirstName.touched && employeeFirstName.errors?.pattern) {
                      <span>{{firstNameElement?.error}}</span>
                    }
                    @if (employeeFirstName.touched && employeeFirstName.hasError('required')) {
                      <span>{{firstNameElement?.error}}</span>
                    }
                    @if (employeeFirstName.touched && (employeeFirstName.errors?.maxlength && !employeeFirstName.hasError('required'))) {
                      <span>
                        <span>First Name cannot be more than 50 characters</span>
                      </span>
                    }
                  </span>

                  <prism-ui-input-text autocomplete="new-password"
                    autofill="off" slot="input"  ngDefaultControl
                    [name]="employeeFirstNameName" formControlName="employeeFirstName"
                    [formGroup]="employeeInfoForm" is-disabled="false"
                    is-required="true" key-id="employeeFirstName" [attr.max-length]="maxLengthName"
                    [isValid]="formControlUtilitiesService.isControlValid(employeeInfoForm,'employeeFirstName')"
                    (focusout)="firstNameLeaveEvent($event)"
                    placeholder="{{firstNameElement?.placeholder}}" >
                  </prism-ui-input-text>

                </prism-ui-form-field>
              }
            </div>
          </div>
          <div class="alignItems">
            <div class="item lastName">
              @if (isEmployeeViewMode) {
                <div class="employeeViewMode">
                  <prism-ui-data-display
                    key-id="employeeLastName-display"
                    [label]="lastNameElement?.label"
                    [value]="employeeInfoForm.get('employeeLastName')?.value"
                  ></prism-ui-data-display>
                </div>
              } @else {
                <prism-ui-form-field key-id="employeeLastName" [isValid]="formControlUtilitiesService.isControlValid(employeeInfoForm , 'employeeLastName')" >

                  <span slot="label">{{lastNameElement?.label}}</span>
                  <span slot="helper-text">{{ lastNameElement?.hint }}</span>
                  <span slot="error">
                    @if (employeeLastName.touched && employeeLastName.errors?.pattern) {
                      <span>{{lastNameElement?.error}}</span>
                    }
                    @if (employeeLastName.touched && employeeLastName.hasError('required')) {
                      <span>{{lastNameElement?.error}}</span>
                    }
                    @if (employeeLastName.touched && (employeeLastName.errors?.maxlength && !employeeLastName.hasError('required'))) {
                      <span>
                        <span>Last Name cannot be more than 50 characters</span>
                      </span>
                    }
                  </span>

                  <prism-ui-input-text autocomplete="new-password"
                    autofill="off" slot="input" [name]="employeeLastNameName"
                    ngDefaultControl formControlName="employeeLastName"
                    [isValid]="formControlUtilitiesService.isControlValid(employeeInfoForm , 'employeeLastName')"
                    [formGroup]="employeeInfoForm" is-disabled="false"
                    is-required="true" key-id="employeeLastName" (focusout)="lastNameLeaveEvent($event)"
                    [attr.max-length]="maxLengthName" placeholder="{{lastNameElement?.placeholder}}">
                  </prism-ui-input-text>

                </prism-ui-form-field>
              }
            </div>
          </div>
        </div>
        @if (isEmployeeViewMode) {
          <div class="containerOne">
            <div class="alignItems">
              <div class="item employeeViewMode">
                <prism-ui-data-display
                  key-id="employeeBirthDate-display"
                  [label]="dateOfBirthElement?.label"
                  [value]="getFormattedDate(employeeInfoForm.get('employeeBirthDateMonth')?.value, employeeInfoForm.get('employeeBirthDateDay')?.value, employeeInfoForm.get('employeeBirthDateYear')?.value)"
                ></prism-ui-data-display>
              </div>
            </div>
          </div>
        } @else {
          <div class="containerDateHeader">
            <div class="item headerDate">
              <prism-ui-form-field
                key-id="employeeBirthDateError"
                [isValid]="isEmployeeBirthDateValid()"
                >

                <span slot="label">{{ dateOfBirthElement?.label }}</span>
                <span slot="helper-text">{{ dateOfBirthElement?.hint }}</span>
                @if (!isEmployeeBirthDateValid()) {
                  <span slot="error" >{{ dateOfBirthElement?.error }}</span>
                }

              </prism-ui-form-field>
            </div>
          </div>
          <div class="containerDateBody">
            <div class="item mm">
              <prism-ui-input-number
                autocomplete="new-password"
                autofill="off"
                slot="input"
                is-required="true"
                formControlName="employeeBirthDateMonth"
                [name]="employeeBirthDateMonthName"
                key-id="employeeBirthDateMonth"
                ngDefaultControl
                placeholder="MM"
                max="12"
                min="1"
                max-length="2"
                min-length="1"
                (focusout)="employeeBirthDateMonthLeaveEvent()"
                [isValid]="formControlUtilitiesService.isControlValid(employeeInfoForm, 'employeeBirthDateMonth')"
              ></prism-ui-input-number>
            </div>
            <div class="item dd">
              <prism-ui-input-number
                autocomplete="new-password"
                autofill="off"
                slot="input"
                is-required="true"
                formControlName="employeeBirthDateDay"
                [name]="employeeBirthDateDayName"
                key-id="employeeBirthDateDay"
                ngDefaultControl
                placeholder="DD"
                max="31"
                min="1"
                max-length="2"
                min-length="1"
                (focusout)="employeeBirthDateDayLeaveEvent()"
                [isValid]="formControlUtilitiesService.isControlValid(employeeInfoForm, 'employeeBirthDateDay')"
              ></prism-ui-input-number>
            </div>
            <div class="item yyyy">
              <prism-ui-input-number
                autocomplete="new-password"
                autofill="off"
                slot="input"
                is-required="true"
                formControlName="employeeBirthDateYear"
                [name]="employeeBirthDateYearName"
                key-id="employeeBirthDateYear"
                ngDefaultControl
                placeholder="YYYY"
                max="birthDayStartDate"
                min="birthDayDatePickerStartAt"
                max-length="4"
                min-length="4"
                (focusout)="employeeBirthDateYearLeaveEvent()"
                [isValid]="formControlUtilitiesService.isControlValid(employeeInfoForm, 'employeeBirthDateYear')"
              ></prism-ui-input-number>
            </div>
          </div>
        }
         @if (isEmployeeViewMode) {
          <div class="containerOne">
            <div class="alignItems">
              <div class="item employeeViewMode">
                <prism-ui-data-display
                  key-id="employer-display"
                  [label]="employerElement?.label"
                  [value]="employeeInfoForm.get('employer')?.value"
                ></prism-ui-data-display>
              </div>
            </div>
          </div>
        } @else {
        <div class="containerGroup">
          <div class="item group">
            <prism-ui-form-field key-id="employeeEmployer" [isValid]="formControlUtilitiesService.isControlValid(employeeInfoForm,'employer')">

              <span slot="label">{{employerElement?.label}}</span>
              <span slot="helper-text">{{ tooltipEmployerDescription }}</span>
              <span slot="error">
                @if (employer.touched && employer.hasError('required')) {
                  <span>{{ employerElement?.error }}</span>
                }
                @if (employer.touched && employer.errors?.maxlength && !employer.hasError('required')) {
                  <span>
                    <span>Employer cannot be more than 150 characters</span>
                  </span>
                }
              </span>

              <prism-ui-input-text autocomplete="new-password"
                autofill="off" slot="input" ngDefaultControl formControlName="employer"
                [name]="employer" [formGroup]="employeeInfoForm" is-readonly="true"
                is-required="true" key-id="employeeEmployer" [defaultValue]="employeeInfoForm.get('employer')?.value"
                max-length="{{maxlengthEmployer}}" placeholder="{{employerElement?.placeholder}}"
                [isValid]="formControlUtilitiesService.isControlValid(employeeInfoForm,'employer')"
              ></prism-ui-input-text>

            </prism-ui-form-field>
          </div>
        </div>
      }
        @if (isEmployeeViewMode) {
          <div class="containerOne">
            <div class="alignItems">
              <div class="item employeeViewMode">
                <prism-ui-data-display
                  key-id="employeeHireDate-display"
                  [label]="dateOfHireElement?.label"
                  [value]="getFormattedDate(employeeInfoForm.get('employeeHireDateMonth')?.value, employeeInfoForm.get('employeeHireDateDay')?.value, employeeInfoForm.get('employeeHireDateYear')?.value)"
                ></prism-ui-data-display>
              </div>
            </div>
          </div>
        } @else {
          <div class="containerDateHeader">
            <div class="item headerDate">
              <prism-ui-form-field
                key-id="employeeBirthDateError"
                [isValid]="isEmployeeHireDateValid()"
                >

                <span slot="label">{{ dateOfHireElement?.label }}</span>
                @if (!isEmployeeHireDateValid()) {
                  <span slot="error" >{{ dateOfHireElement?.error }}</span>
                }

              </prism-ui-form-field>
            </div>
          </div>
          <div class="containerDateBody">
            <div class="item mm">
              <prism-ui-input-number
                autocomplete="new-password"
                autofill="off"
                slot="input"
                is-required="true"
                formControlName="employeeHireDateMonth"
                [name]="employeeHireDateMonthName"
                key-id="employeeHireDateMonth"
                ngDefaultControl
                placeholder="MM"
                max="12"
                min="1"
                max-length="2"
                min-length="1"
                (focusout)="employeeHireDateMonthLeaveEvent()"
                [isValid]="formControlUtilitiesService.isControlValid(employeeInfoForm, 'employeeHireDateMonth')"
              ></prism-ui-input-number>
            </div>
            <div class="item dd">

              <prism-ui-input-number
                autocomplete="new-password"
                autofill="off"
                slot="input"
                is-required="true"
                formControlName="employeeHireDateDay"
                [name]="employeeHireDateDayName"
                key-id="employeeHireDateDay"
                ngDefaultControl
                placeholder="DD"
                max="31"
                min="1"
                max-length="2"
                min-length="1"
                (focusout)="employeeHireDateDayLeaveEvent()"
                [isValid]="formControlUtilitiesService.isControlValid(employeeInfoForm, 'employeeHireDateDay')"
              ></prism-ui-input-number>

            </div>
            <div class="item yyyy">
              <prism-ui-input-number
                autocomplete="new-password"
                autofill="off"
                slot="input"
                is-required="true"
                formControlName="employeeHireDateYear"
                [name]="employeeHireDateYearName"
                key-id="employeeHireDateYear"
                ngDefaultControl
                placeholder="YYYY"
                max="birthDayStartDate"
                min="birthDayDatePickerStartAt"
                max-length="4"
                min-length="4"
                (focusout)="employeeHireDateYearLeaveEvent()"
                [isValid]="formControlUtilitiesService.isControlValid(employeeInfoForm, 'employeeHireDateYear')"
              ></prism-ui-input-number>
            </div>
          </div>
          <div class="containerHint">
            <div class="item DohHint">
              <prism-ui-form-field
                key-id="employeeHireDateHint"
                >

                <span slot="helper-text">{{ dateOfHireElement?.hint }}</span>

              </prism-ui-form-field>
            </div>
          </div>
        }
        <div class="containerTwo">
          <div class="alignItems">
            <div class="item occupation">
              @if (isEmployeeViewMode) {
                <div class="employeeViewMode">
                  <prism-ui-data-display
                    key-id="employeeOccupation-display"
                    [label]="!isGenericDynamicForm ? occupationElement?.label : jobTitleElement?.label"
                    [value]="employeeInfoForm.get('position')?.value"
                  ></prism-ui-data-display>
                </div>
              } @else {
                <prism-ui-form-field key-id="employeeOccupation"
                  [isValid]="formControlUtilitiesService.isControlValid(employeeInfoForm , 'position')" >

                  @if (!isGenericDynamicForm) {
                    <span slot="label">{{occupationElement?.label}}</span>
                  }
                  @if (isGenericDynamicForm) {
                    <span slot="label">{{jobTitleElement?.label}}</span>
                  }
                  @if (!isGenericDynamicForm) {
                    <span slot="helper-text">{{occupationElement?.hint}}</span>
                  }
                  @if (isGenericDynamicForm) {
                    <span slot="helper-text">{{jobTitleElement?.hint}}</span>
                  }
                  <span slot="error">
                    @if (position.touched && position.errors?.pattern && !isGenericDynamicForm) {
                      <span >{{occupationElement?.error}}</span>
                    }
                    @if (position.touched && position.hasError('required') && !isGenericDynamicForm) {
                      <span>{{occupationElement?.error}}</span>
                    }
                    @if (position.touched && position.errors?.pattern && isGenericDynamicForm) {
                      <span >{{jobTitleElement?.error}}</span>
                    }
                    @if (position.touched && position.hasError('required') && isGenericDynamicForm) {
                      <span>{{jobTitleElement?.error}}</span>
                    }
                    @if (position.touched && (position.errors?.maxlength && !position.hasError('required'))) {
                      <span>
                        @if (!isGenericDynamicForm) {
                          <span>{{occupationErrorElement?.error}}</span>
                        }
                        @if (isGenericDynamicForm) {
                          <span>{{jobTitleErrorElement?.label}}</span>
                        }
                      </span>
                    }
                  </span>

                  @if (!isGenericDynamicForm) {
                    <prism-ui-input-text autocomplete="new-password"
                      autofill="off" slot="input" [name]="positionName"
                      ngDefaultControl formControlName="position"
                      [isValid]="formControlUtilitiesService.isControlValid(employeeInfoForm , 'position')"
                      [formGroup]="employeeInfoForm" is-disabled="false"
                      is-required="true" key-id="employeeOccupation"
                      max-length="{{maxLengthOccupation}}" placeholder="{{occupationElement?.placeholder}}"
                    pattern="^(.*[^ ].*)$" (focusout)="occupationLeaveEvent($event)"></prism-ui-input-text>
                  }

                  @if (isGenericDynamicForm) {
                    <prism-ui-input-text autocomplete="new-password"
                      autofill="off" slot="input" [name]="positionName"
                      ngDefaultControl formControlName="position"
                      [isValid]="formControlUtilitiesService.isControlValid(employeeInfoForm , 'position')"
                      [formGroup]="employeeInfoForm" is-disabled="false"
                      is-required="true" key-id="employeeOccupation"
                      max-length="{{maxLengthOccupation}}" placeholder="{{jobTitleElement?.label}}"
                    pattern="^(.*[^ ].*)$" (focusout)="occupationLeaveEvent($event)"></prism-ui-input-text>
                  }

                </prism-ui-form-field>
              }
            </div>
          </div>
          <div class="alignItems">
            <div class="item earnings">
              @if (isEmployeeViewMode) {
                <div class="employeeViewMode">
                  <prism-ui-data-display
                    key-id="employeeEarnings-display"
                    [label]="salaryElement?.label"
                    [value]="employeeInfoForm.get('earnings')?.value"
                  ></prism-ui-data-display>
                </div>
              } @else {
                <prism-ui-form-field key-id="employeeEarnings"
                  [isValid]="formControlUtilitiesService.isControlValid(employeeInfoForm , 'earnings')" >
                  <span slot="label">{{salaryElement?.label}}</span>
                  <span slot="helper-text">{{tooltipEarningsDescription}}</span>
                  <span slot="error">
                    <span>{{ salaryElement?.error }}</span>
                  </span>
                  <prism-ui-input-currency
                    slot="input"
                    autocomplete="new-password"
                    autofill="off"
                    [formGroup]="employeeInfoForm"
                    ngDefaultControl
                    formControlName="earnings"
                    is-disabled="false"
                    is-required="true"
                    [isValid]="formControlUtilitiesService.isControlValid(employeeInfoForm , 'earnings')"
                    key-id="employeeEarnings"
                    [maxLength] ="maxLengthSalary"
                    [name]="employeeEarningsName"
                    placeholder="{{salaryElement?.placeholder}}"
                    (focusout)="earningLeaveEvent($event)"
                    size="md"
                  ></prism-ui-input-currency>
                </prism-ui-form-field>
              }
            </div>
          </div>
          <div class="alignItems">
            <div class="item ssn">
              @if (isEmployeeViewMode) {
                <div class="employeeViewMode">
                  <prism-ui-data-display
                    key-id="employeeSsn-display"
                    [label]="ssnElement?.label"
                    [value]="getMaskedSsn(employeeInfoForm.get('employeeSsn')?.value)"
                  ></prism-ui-data-display>
                </div>
              } @else {
                <prism-ui-form-field key-id="employeeSsn"
                  [isValid]="formControlUtilitiesService.isSsnControlValid(employeeInfoForm , 'employeeSsn')" >
                  <span slot="label">{{ssnElement?.label}}</span>
                  <span slot="helper-text">{{ssnElement?.hint}}</span>
                  <span slot="error">
                    @if (employeeSsn.hasError('required')) {
                      <span>{{ssnElement?.error}}</span>
                    }
                    @if (employeeSsn.hasError('pattern')) {
                      <span>{{ ssnInvalidErrorElement?.error }}</span>
                    }
                    @if (employeeSsn.hasError('invalidSsn')) {
                      <span>{{ ssnInvalidErrorElement?.error }}</span>
                    }
                    @if (employeeSsn.hasError('ssnMatchesEmployee')) {
                      <span>{{ ssnMatchErrorElement?.error }}</span>
                    }
                  </span>
                </prism-ui-form-field>
                <div class="container">
                  <div class="item ssnBox">
                    <prism-ui-input-ssn
                      aria-label="Enter your social security number"
                      is-small="false"
                      is-valid="true"
                      key-id="employeeSsn"
                      default-value=""
                      is-hidden="false"
                      autocomplete="new-password"
                      autofill="off"
                      formControlName="employeeSsn"
                      [formGroup]="employeeInfoForm"
                      [name]="employeeSsnName"
                      [isValid]="formControlUtilitiesService.isSsnControlValid(employeeInfoForm , 'employeeSsn')"
                      (focusout)="formControlUtilitiesService.ssnLeaveEvent(employeeInfoForm , 'employeeSsn', hasSsnMatch)"
                      ngDefaultControl
                      (inputSsnChange)="handleChangeEvent($event)"
                      is-hidden="true"
                      >
                    </prism-ui-input-ssn>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </prism-ui-container>
      <div class="center continueCancelButtonPadding">
        @if (isEditFromReview) {
          <prism-ui-button-group
            key-id="employee-edit-button-group"
            buttons-count="2"
            spacing="default"
            class="editActionButtons"
          >
            <prism-ui-button
              slot="1"
              button-width="full"
              key-id="back-button"
              size="md"
              variant="secondary"
              type="button"
              is-icon-right-aligned="false"
              (click)="goBack()"
            >Back</prism-ui-button>
            @if (!isEmployeeViewMode) {
              <prism-ui-button
              slot="2"
              button-width="full"
              key-id="save-button"
              size="md"
              variant="primary"
              type="button"
              is-icon-right-aligned="false"
              [attr.is-inactive]="isSavingEdit ? 'true' : null"
              (click)="saveAndGoToReview()"
            >Save</prism-ui-button>
            }
          </prism-ui-button-group>
        } @else {
          <app-continue-cancel (cancelEmitter)="onCancel()"></app-continue-cancel>
        }
      </div>

    </form>

    @if (formSubmitted) {
      <div class="page-loader">
        <prism-ui-loader
          has-logo="false"
          is-reverse="false"
          key-id="page-loader"
          size="md"
          >
        </prism-ui-loader>
        <prism-ui-copy
          font-size="md"
          font-style="normal"
          font-weight="regular"
          key-id="spinner-loading-text"
          line-height="medium"
          text-decoration="none"
          variant="default"
          >
          <span>Please wait while we process your request</span>
        </prism-ui-copy>
      </div>
    }
  
  }

  </prism-ui-page-content>
